import { gql } from '@apollo/client';
import React from 'react';
import ReactDOM from 'react-dom';
import { GraphQLContext, IFields, IItemFields } from '../../../.starryUI/context/GraphQLContext';
import { entryDirectoryCurrentPage, entryDirectoryPageAmount, entryDirectorySearchFor, entryDirectorySorting } from './cache';
import { AppProvider } from './context/AppContext';
import { EntryDirectoryProvider, IEntryDirectoryEvents } from './context/EntryDirectoryContext';
import { EntryDirectory } from './pages/EntryDirectory';
import { GetViewType } from './utils/typeUtil';

declare global {
    interface Window {
        RenderEntryDirectory: global.GlobalFunction<IEntryDirectoryEvents>;
    }
}

export const fields: IFields = {
    _mainDirectorySorting: {
        read() {
            return entryDirectorySorting();
        },
    },
    _mainDirectoryCurrentPage: {
        read() {
            return entryDirectoryCurrentPage();
        },
    },
    _mainDirectoryPageAmount: {
        read() {
            return entryDirectoryPageAmount();
        },
    },
    _mainDirectorySearchFor: {
        read() {
            return entryDirectorySearchFor();
        },
    },
};

const itemFields: IItemFields = {
    DirectoryList: {
        fields: {
            viewType: {
                read(_, { readField }) {
                    return GetViewType(readField('listType') as starrez.DirectoryListTypeEnum);
                },
            },
        },
    },
};

const typeDefs = gql`
    type _GridSorting {
        field: String!
        order: String!
    }

    extend type Query {
        _mainDirectorySorting: _GridSorting!
        _mainDirectoryCurrentPage: Number!
        _mainDirectorySearchFor: String!
    }
`;

window.RenderEntryDirectory = (divID, connection = process.env.GRAPHQL_ENDPOINT, events) => {
    const element = document.getElementById(divID) as HTMLDivElement;
    if (element) {
        ReactDOM.render(
            <GraphQLContext fields={fields} itemFields={itemFields} typeDefs={typeDefs} connection={connection!}>
                <EntryDirectoryProvider value={events!}>
                    <AppProvider>
                        <EntryDirectory />
                    </AppProvider>
                </EntryDirectoryProvider>
            </GraphQLContext>,
            element
        );
    }
};
